import IComponent from "components/commons/IComponent";
import "./PanelBase.scoped.css";
import "./BookmarkManager.scoped.css";
import SwitchTabs from "components/commons/SwitchTabs";
import moment from "moment";
import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import SwitchButton from "components/commons/SwitchButton";
import { setUserCanManageBm, setManageBmRightChecked } from "store/globalSlice";
import BookmarkUtils from "utils/BookmarkUtils";
import DivTable from "components/commons/DivTable";

class BookmarkManager extends IComponent {
  bookmarkSrvUrl = null;
  constructor(props) {
    super(props);
    this.state = {
      bookmarks: [],
      panelMode: 0,
      isGlobal: false,
      editingBookmarkData: {
        name: "Foo",
        desc: "Bar",
      },
      isLoading: false,
      canManageGlobal: false,
    };
    this.bookmarkSrvUrl = this.$config.webSrvUrl + "Bookmark";
    BookmarkUtils.prepareLayerHashTable(this.$config.mapList);
  }
  componentDidMount() {
    this.queryForBookmarks();
    if (!this.props.reduxStore.global.didManageBmRightChecked) {
      this.fetchQueryByGET(this.bookmarkSrvUrl + "/CanManageGlobalBm")
        .then((response) => response.json())
        .then((result) => {
          this.props.reduxCallProxy(setManageBmRightChecked);
          if (result) {
            this.props.reduxCallProxy(setUserCanManageBm);
            this.setState({
              canManageGlobal: true,
            });
          }
        });
    } else {
      this.setState({
        canManageGlobal: this.props.reduxStore.global.canManageGlobal,
      });
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.currentDialogHeight != prevProps.currentDialogHeight) {
      this.setState({});
    }
  }
  queryForBookmarks() {
    if (true) {
      this.setState({ isLoading: true });
      return this.fetchQueryByGET(this.bookmarkSrvUrl)
        .then((response) => response.json())
        .then((bookmarks) => {
          bookmarks.forEach((i) => {
            try {
              i.json = JSON.parse(i.json);
              i.name = i.json.name;
              i.desc = i.json.desc;
            } catch (e) {
              i.name = "Invalid Bookmark";
              i.desc = "The boookmark data is damaged";
              i.error = true;
            }
          });
          bookmarks = bookmarks.filter((i) => i.json.is3D == this.props.is3D);
          this.setState({ bookmarks });
        })
        .catch((e) => this.setState({ bookmarks: undefined }))
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
  }
  deleteBookmark(item) {
    this.props.showDialog({
      type: "prompt",
      isOpen: true,
      title: "Delete a bookmark",
      content: (
        <div>
          <div>Are you sure to delete this bookmark?</div>
          <div className="spacer" />
          <div>{item.name}</div>
        </div>
      ),
      onDialogOk: () => {
        setTimeout(() =>
          this.props.showDialog({
            isOpen: true,
            title: "Deleting bookmark",
            content: (
              <div>
                <span className="icn_loading" />
                Deleting the bookmark data, please wait...
              </div>
            ),
          })
        );
        this.fetchQueryMain(this.bookmarkSrvUrl + `?id=${item.id}`, "DELETE")
          .then((i) => this.queryForBookmarks())
          .then(() =>
            this.props.showDialog({
              isOpen: false,
            })
          );
      },
      onDialogCancel: () => {},
    });
  }
  editBookmark(item) {
    this.setState({
      editingBookmarkData: { ...item },
      panelMode: 2,
    });
  }
  applyBookmark(item) {
    try {
      if (item.error) return;

      BookmarkUtils.fromJson(this.props.mapView, item.json);

      this.props.showDialog({
        isOpen: false,
      });
    } catch (e) {
      console.debug("Invalid bookmark", e);
      this.props.mapView.map.basemap.baseLayers.items[0].visible = true;
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Failed to apply the bookmark",
        content: "Error occurred when trying to apply the bookmark",
        jsxElement: e.toString(),
        onDialogOk: () => {},
      });
    }
  }
  saveBookmarkConfirmation(saveUnenabled = false) {
    this.props.showDialog({
      type: "prompt",
      isOpen: true,
      title: "Confirm to save bookmark",
      content: (
        <div>
          Are you sure to save the bookmark?{" "}
          {this.state.panelMode == 2 && (
            <p>
              By saving the bookmark, current bookmark will be overwritten by a
              new bookmark with the new name, description and current map state
            </p>
          )}
        </div>
      ),
      jsxElement: this.props.is3D && (
        <SwitchButton
          label="Also save the 3D layer(s) that is added but not enabled"
          checked={saveUnenabled}
          onClick={() => {
            saveUnenabled = !saveUnenabled;
            this.saveBookmarkConfirmation(saveUnenabled);
          }}
        />
      ),
      onDialogOk: () => this.saveBookmark(saveUnenabled),
      onDialogCancel: () => {},
    });
  }
  saveBookmark(saveUnenabled) {
    let json = BookmarkUtils.toJson(
      this.props.mapView,
      this.props.is3D,
      saveUnenabled
    );
    json = { ...json, ...this.state.editingBookmarkData };

    let args = [];
    if ("id" in json) args = [this.bookmarkSrvUrl + "?id=" + json.id, "PATCH"];
    else args = [this.bookmarkSrvUrl, "PUT"];

    delete json.json;

    args.push(JSON.stringify(json));

    setTimeout(() =>
      this.props.showDialog({
        isOpen: true,
        title: "Saving bookmark",
        content: (
          <div>
            <span className="icn_loading" />
            Saving the bookmark data, please wait...
          </div>
        ),
      })
    );
    this.fetchQueryMain
      .apply(this, args)
      .then(this.queryForBookmarks.bind(this))
      .then(() => {
        this.props.showDialog({
          isOpen: true,
          title: "Save bookmark change",
          content: "Change saved successfully",
          onDialogOk: () => this.setState({ panelMode: 0 }),
        });
      });
  }
  render() {
    let {
      panelMode,
      editingBookmarkData,
      bookmarks,
      isGlobal,
      isLoading,
      canManageGlobal,
    } = this.state;
    let styleObj = isGlobal && !canManageGlobal ? { display: "none" } : {};
    return (
      <div>
        <div
          className="PanelBaseTitle EqualWidthChildren"
          style={{ height: "60px" }}
        >
          <span style={{ paddingLeft: "8px" }}>
            {(panelMode == 0 ? "" : panelMode == 1 ? "Add " : "Edit ") +
              "Bookmark"}
          </span>
          <div className="AddBookmarkButton">
            {panelMode == 0 && (!isGlobal || (isGlobal && canManageGlobal)) && (
              <Button
                variant="contained"
                onClick={() =>
                  this.setState({
                    editingBookmarkData: {
                      name: "",
                      desc: "",
                    },
                    panelMode: 1,
                  })
                }
              >
                <span className="icn_tool_zoomin" />
                Bookmark
              </Button>
            )}
          </div>
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.props.mapUICallback("hideAllPanel")}
          />
        </div>
        <div className="PanelContent" style={{ height: "calc(100% - 60px)" }}>
          {panelMode === 0 && (
            <div>
              <SwitchTabs
                activedTab={isGlobal ? 1 : 0}
                tabText={["My Own Bookmark", "Global Bookmark"]}
                onSwitchTabCallback={(e) => {
                  this.bookmarkSrvUrl =
                    this.$config.webSrvUrl +
                    "Bookmark" +
                    (e === 1 ? "/Global" : "");
                  this.setState(
                    {
                      bookmarks: [],
                      isGlobal: e === 1,
                    },
                    () => this.queryForBookmarks()
                  );
                }}
              />
              <div style={{ height: `${this.props.currentDialogHeight}px` }}>
                <DivTable
                  data={bookmarks}
                  columnDef={[
                    {
                      name: "Name",
                      value: "name",
                      format: (value, row) => (
                        <span
                          className="BookmarkLink"
                          onClick={() => this.applyBookmark(row)}
                        >
                          {value}
                        </span>
                      ),
                    },
                    {
                      name: "Description",
                      value: "desc",
                    },
                    {
                      name: "Create Date",
                      value: "date",
                      width: "100px",
                      format: (value) => moment(value).format("YYYY-MM-DD"),
                    },
                  ]}
                  actionColumn={
                    !isGlobal || (isGlobal && canManageGlobal)
                      ? [
                          {
                            className: "icn_3d_Elevationprofile_draw icon_s",
                            onClick: (row) => this.editBookmark(row),
                          },
                          {
                            className: "icn_graphicsearch_delete icon_s",
                            onClick: (row) => this.deleteBookmark(row),
                          },
                        ]
                      : undefined
                  }
                  noDataText={function() {
                    if (typeof bookmarks === "undefined")
                      return "Unable to retrieve your bookmark at the moment";
                    else if (isLoading)
                      return (
                        <div>
                          <span className="icn_loading" /> Refreshing your
                          bookmark..
                        </div>
                      );
                    else if (!isLoading && bookmarks?.length === 0)
                      return this.state.isGlobal
                        ? "No Global Bookmark Available"
                        : "No bookmark to show. Get started by adding one now!";
                  }.apply(this)}
                />
              </div>
            </div>
          )}
          {panelMode > 0 && (
            <div className="BookmarkEditForm" style={{ width: "97%" }}>
              <div>
                <div>Name</div>
                <EditableDatagridCell
                  cellInfo={{
                    colDef: {
                      field: "name",
                      dataType: "text",
                    },
                    row: editingBookmarkData,
                  }}
                  onChange={(field, value, values) => {
                    this.setState({
                      editingBookmarkData: {
                        ...editingBookmarkData,
                        [field]: value,
                      },
                    });
                  }}
                />
              </div>
              <div className="spacer" />
              <div className="spacer" />
              <div>
                <div>Description</div>
                <div>
                  <EditableDatagridCell
                    cellInfo={{
                      colDef: {
                        field: "desc",
                        dataType: "text",
                        multiline: true,
                      },
                      row: editingBookmarkData,
                    }}
                    onChange={(field, value, values) => {
                      this.setState({
                        editingBookmarkData: {
                          ...editingBookmarkData,
                          [field]: value,
                        },
                      });
                    }}
                  />
                </div>
              </div>
              <div className="spacer" />
              <div>
                <div />
                <div className="EqualWidthChildren">
                  <div>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        this.setState({
                          panelMode: 0,
                        })
                      }
                      style={{ width: "100px", marginTop: "10px" }}
                    >
                      Cancel
                    </Button>
                  </div>
                  <div className="AlignRight">
                    <Button
                      variant="contained"
                      onClick={() => this.saveBookmarkConfirmation()}
                      style={{ width: "100px", marginTop: "10px" }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default BookmarkManager;
